import * as React from 'react';
import clsx from 'clsx';
import videoAvatarOn from '@/assets/images/svg/video_avatar_on.svg';
import videoAvatarOff from '@/assets/images/svg/video_avatar_off.svg';

const InfoTooltip: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  React.useEffect(() => {
    if (open) {
      const timer = setTimeout(() => setOpen(false), 3000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [open]);

  return (
    <div
      ref={ref}
      className='relative flex items-center'
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type='button'
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className='flex size-[14px] items-center justify-center rounded-full bg-gray-350/70 font-proxima text-[8px] font-extrabold lowercase leading-[47px] tracking-normal text-white'
        aria-label='Video cost info'
      >
        i
      </button>
      {open && (
        <div
          className={clsx(
            'absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2',
            'whitespace-nowrap bg-gray-660 px-[15px] py-[6px]',
            'rounded-t-[10px] rounded-bl-none rounded-br-[10px]'
          )}
        >
          <span className='font-sans text-10 font-normal leading-[15px] tracking-normal text-white'>
            VIDEO costs{' '}
            <span className='font-sans text-10 font-normal leading-[15px] tracking-normal text-white'>
              5
            </span>{' '}
            extra credits
          </span>
        </div>
      )}
    </div>
  );
};

interface VideoToggleButtonProps {
  isEnabled: boolean;
  onClick: () => void;
  className?: string;
}

const SHOW_COST_INFO = false;

export const VideoToggleButton: React.FC<VideoToggleButtonProps> = ({
  isEnabled,
  onClick,
  className,
}) => (
  <div className='flex items-center gap-1.5'>
    <button
      type='button'
      onClick={onClick}
      className={clsx(
        'flex items-center justify-center gap-1 rounded-[10px] px-[9px]',
        'transition-all duration-200 hover:opacity-90',
        'bg-white/10 text-white hover:bg-white/20',
        className
      )}
    >
      <img
        src={isEnabled ? videoAvatarOn : videoAvatarOff}
        alt='Video'
        className='size-[12px] object-contain'
      />
      <span className='font-sans text-[12px] font-normal leading-[27px] tracking-normal'>
        {isEnabled ? 'video on' : 'video off'}
      </span>
    </button>
    {SHOW_COST_INFO && <InfoTooltip />}
  </div>
);
